// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatIntroController from "./chat_intro_controller"
application.register("chat-intro", ChatIntroController)

import ChatIntroSwiperController from "./chat_intro_swiper_controller"
application.register("chat-intro-swiper", ChatIntroSwiperController)

import ChatMessageController from "./chat_message_controller"
application.register("chat-message", ChatMessageController)

import ConversationOpenerController from "./conversation_opener_controller"
application.register("conversation-opener", ConversationOpenerController)

import DraggableController from "./draggable_controller"
application.register("draggable", DraggableController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InputCharacterCounterController from "./input_character_counter_controller"
application.register("input-character-counter", InputCharacterCounterController)

import MessageController from "./message_controller"
application.register("message", MessageController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SpecialCharactersController from "./special_characters_controller"
application.register("special-characters", SpecialCharactersController)

import SpeechToTextController from "./speech_to_text_controller"
application.register("speech-to-text", SpeechToTextController)

import SubmitOnChangeController from "./submit_on_change_controller"
application.register("submit-on-change", SubmitOnChangeController)

import TextSpeechController from "./text_speech_controller"
application.register("text-speech", TextSpeechController)

import TextSwitchController from "./text_switch_controller"
application.register("text-switch", TextSwitchController)

import TranslationController from "./translation_controller"
application.register("translation", TranslationController)
